export const environment = {
    production: false,

    BASE_API: "https://dev.api.reset.wginb.com",
    RESET_PASSWORD_ENDPOINT: "https://dev.api.reset.wginb.com/ssoresetv2/reset"
};
